import {GameModeTransitionControllerWithView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionControllerWithView";
import {GameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionView";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";

export class TOAGameModeTransitionControllerWithView extends GameModeTransitionControllerWithView{
    private _fromModeList : string[] = [];
    constructor(fromMode: string[], toMode: string, view: GameModeTransitionView){
        super(fromMode[0], toMode, view);
        this._fromModeList = fromMode;
    }

    protected calculateIsTriggeredThisSpin(data: ParsedServerData): boolean {
        return this._fromModeList.indexOf(data.mode) > -1 && this._toMode == data.nextMode;
    }

} 